<template>
  <el-row v-if="newsList.length" class="home-row-carousel">
    <el-col :xs="24" :sm="{ span: 22, offset: 1 }" :md="{ span: 20, offset: 2 }" :lg="{ span: 20, offset: 2 }">
      <div class="announcement-bar">
        <i class="el-icon-bell announcement-icon"></i>
        <div class="announcement-body">
          <div class="announcement-title-wrap">
            <el-tooltip :content="currentItem.title" placement="top" :disabled="!isTitleEllipsis">
              <transition name="scroll-up" mode="out-in">
                <span :key="(currentItem && currentItem.id) || currentIndex" ref="titleText" class="announcement-title clickable" @click="goDetail(currentItem)">{{ currentItem.title }}</span>
              </transition>
            </el-tooltip>
          </div>
        </div>
        <div class="announcement-more" @click="goDetail(currentItem)">
          <span>查看更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'AnnouncementBar',
  data () {
    return {
      newsList: [],
      currentIndex: 0,
      carouselTimer: null,
      isTitleEllipsis: false
    }
  },
  computed: {
    currentItem () {
      return this.newsList[this.currentIndex] || {}
    }
  },
  mounted () {
    this.fetchCarouselNews()
    window.addEventListener('resize', this.updateTitleEllipsis)
  },
  beforeDestroy () {
    this.stopCarousel()
    window.removeEventListener('resize', this.updateTitleEllipsis)
  },
  watch: {
    currentIndex () {
      this.updateTitleEllipsis()
    }
  },
  methods: {
    fetchCarouselNews () {
      this.$http.post('/door/service/getNewsByPage', {
        pageNum: 1,
        pageSize: 1000,
        status: 2,
        carousel: 1
      }).then((res) => {
        this.newsList = res.data.newsList || []
        this.currentIndex = 0
        this.stopCarousel()
        if (this.newsList.length > 1) {
          this.startCarousel()
        }
        this.updateTitleEllipsis()
      })
    },
    startCarousel () {
      this.carouselTimer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.newsList.length
      }, 5000)
    },
    stopCarousel () {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
        this.carouselTimer = null
      }
    },
    updateTitleEllipsis () {
      this.$nextTick(() => {
        const node = this.$refs.titleText
        this.isTitleEllipsis = !!(node && node.scrollWidth > node.clientWidth)
      })
    },
    goDetail (item) {
      if (!item || !item.id) return
      const routeData = this.$router.resolve('/publish/' + item.id)
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.home-row-carousel {
  background: rgba(245, 245, 245, 0.78);

  .announcement-bar {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .announcement-icon {
    flex-shrink: 0;
    font-size: 22px;
    color: #333;
    margin-right: 12px;
  }

  .announcement-body {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    line-height: 24px;
    font-size: 16px;
    color: #333;

  }

  .announcement-prefix {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 4px;
    line-height: 24px;
  }

  .announcement-title {
    display: block;
    width: 100%;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .clickable {
    cursor: pointer;
  }

  .announcement-title-wrap {
    flex: 1;
    min-width: 0;
    height: 24px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .scroll-up-enter-active,
  .scroll-up-leave-active {
    transition: transform 0.96s ease, opacity 0.96s ease;
  }

  .scroll-up-enter {
    transform: translateY(100%);
    opacity: 0;
  }

  .scroll-up-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }

  .announcement-more {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    white-space: nowrap;

    i {
      margin-left: 4px;
      font-weight: bold;
    }
  }
}
</style>
